import {
  Box,
  CircularProgress,
  Typography,
  Fade
} from '@mui/material';

function LoadingState({ 
  message = 'Loading...',
  variant = 'default',
  size = 40
}) {
  const variants = {
    default: {
      sx: { 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        minHeight: 200
      }
    },
    overlay: {
      sx: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }
    },
    inline: {
      sx: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 1
      }
    }
  };

  return (
    <Fade in>
      <Box {...variants[variant]}>
        <CircularProgress size={size} />
        {message && (
          <Typography 
            variant={variant === 'inline' ? 'body2' : 'body1'} 
            color="text.secondary"
            sx={{ mt: variant === 'inline' ? 0 : 2 }}
          >
            {message}
          </Typography>
        )}
      </Box>
    </Fade>
  );
}

export default LoadingState; 